import { ErrorHandler, Injectable } from '@angular/core';
import { LocalStorageService } from '../utility/local-storage.service';
import * as globals from '../utility/global';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    public errorLog: string[] = LocalStorageService.get('errorLog') ? LocalStorageService.get('errorLog') : [];
    constructor() { }
    handleError(error) {
        this.errorLog.push(globals.currentDateTime + " " + error);
        LocalStorageService.set('errorLog', this.errorLog);
        // IMPORTANT: Rethrow the error otherwise it gets swallowed
        throw error;
    }

}